export default "__VITE_ASSET__d40d42f9__"